import { Fragment, MutableRefObject, useLayoutEffect, useRef } from 'react'
import { AssetReference } from '@opallabs/cassini'
import { kuiperClassNames } from '@opallabs/kuiper'
import { PollNumberFuncs, PollNumber, FocusState } from '../..'
import { TwitterStreamFooter } from '../../../sharedDisplays/footers/TwitterStreamFooter'
import { TwitterStreamHeader } from '../../../sharedDisplays/headers/TwitterStreamHeader'
import { Poll } from '../../Poll'
import { pollContainerStyles } from '../../styles'

export interface Props {
  accountImage: AssetReference | null
  accountName: string
  accountUsername: string
  content: string
  focus: FocusState
  index: number
  isAccountPremium?: boolean
  isThreaded: boolean
  modulesLength?: number
  onContentChange: (val: string) => void
  pollNumber?: number
  polls?: string[]
  postType: string
  readOnly: boolean
  resolveFocus: () => void
  updatePollNumber: PollNumberFuncs
  updatePolls: (poll: string, position: number) => void
}

const getQuerySelector = (pollToFocus: number): string => {
  return `.kuiper-option-${pollToFocus} > input`
}

export const DesktopStream: React.FC<Props> = ({
  accountImage,
  accountName,
  accountUsername,
  content,
  focus,
  isAccountPremium,
  isThreaded,
  index,
  modulesLength,
  onContentChange,
  polls,
  postType,
  readOnly,
  resolveFocus,
  updatePollNumber,
  updatePolls,
}) => {
  const pollContainerRef: MutableRefObject<HTMLDivElement | null> = useRef(null)

  useLayoutEffect(() => {
    if (focus.shouldFocus && pollContainerRef.current) {
      const { pollToFocus } = focus
      const query = getQuerySelector(pollToFocus)
      const input = pollContainerRef.current.querySelector(
        query
      ) as HTMLInputElement
      if (input) {
        input.focus()
      }
      resolveFocus()
    }
  }, [focus, resolveFocus])

  return (
    <Fragment>
      <TwitterStreamHeader
        accountImage={accountImage}
        accountName={accountName}
        accountUsername={accountUsername}
        content={content}
        isAccountPremium={isAccountPremium}
        isThreaded={isThreaded}
        modulesLength={modulesLength}
        index={index}
        isMobile={false}
        postType={postType}
        onContentChange={onContentChange}
        readOnly={readOnly}
      />
      <div
        css={pollContainerStyles}
        className={kuiperClassNames('twitter-poll-container')}
        ref={pollContainerRef}
      >
        {polls?.map((poll, index) => (
          <Poll
            poll={poll}
            pollPositions={{
              current: index as PollNumber,
              total: polls.length as PollNumber,
            }}
            updatePollNumber={updatePollNumber}
            readOnly={readOnly}
            updatePoll={(updatedPoll: string) =>
              updatePolls(updatedPoll, index)
            }
            key={`${poll || ''}${index}`}
          />
        ))}
      </div>
      <TwitterStreamFooter isMobile={false} />
    </Fragment>
  )
}
